import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, FullCalendarModule, ToastModule],
  template: `<p-toast position="bottom-left"></p-toast><router-outlet></router-outlet>`,
})
export class App {
  protected readonly title = signal('smart-teacher-availability');
}
